export type EngineRequestBody = {
  /**
   * Engine unit unique factory number/id
   */
  engineNumber?: string | null;
  /**
   * Engine code to specify engine family, often used for parts search
   */
  engineCode?: string | null;
  /**
   * Engine name, often used in vehicle branding
   */
  engineName?: string | null;
  /**
   * Engine volume in cm^3
   */
  engineVolume?: number | null;
  /**
   * Engine cylinders count
   */
  cylinderCount?: number | null;
  /**
   * Transmission gears count
   */
  gearCount?: number | null;
  /**
   * Is DPF present on exhaust system?
   */
  hasDpf?: boolean | null;
  /**
   * Fuel consumption combined in l/100 km
   */
  fuelConsumptionCombined?: number | null;
  /**
   * Urban fuel consumption in l/100 km
   */
  fuelConsumptionUrban?: number | null;
  /**
   * Extra urban fuel consumption in l/100 km
   */
  fuelConsumptionExtraUrban?: number | null;
  /**
   * Engine emission class known as EURO specification
   */
  emissionClass?: string | null;
  /**
   * Engine CO emissions in g/km
   */
  carbonDioxideEmission?: number | null;
  /**
   * Engine max torque
   */
  maxTorque?: string | null;
  /**
   * Power consumption - Combined  (kWh/100 km)
   */
  powerConsumptionCombined?: number | null;
  /**
   * in W, for hybrid, max power of conventional engine (petrol etc..)
   */
  powerCombustionEngine?: number | null;
  /**
   * in W, for hybrid, max power of electric engines
   */
  powerElectricEngine?: number | null;
  /**
   * Additional information about electric engine
   */
  electricEngineNote?: string | null;
  maximalPower?: number | null;
};
